export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10231.bf28bdd5.jpg";